import "../styles/services.css";
import { SERVICES } from "../data/constants";

export default function Services() {
  return (
    <div className="services">
      <div className="services__header">
        <p className="services__eyebrow">WHAT WE OFFER</p>
        <h1 className="services__title">Our Services</h1>
        <p className="services__subtitle">From engine health to chassis care and a spotless finish — covering everything your fleet needs.</p>
      </div>
      {SERVICES.map((s, i) => (
        <div key={s.title} className={"services__item" + (i % 2 !== 0 ? " services__item--reverse" : "")}>
          <div className="services__item-img">
            <img src={s.img} alt={s.title} />
          </div>
          <div className="services__item-body">
            <div className="services__item-icon">{s.icon}</div>
            <h2 className="services__item-title">{s.title}</h2>
            <p className="services__item-desc">{s.desc}</p>
            <div className="services__features">
              {s.features.map((f) => (
                <div key={f} className="services__feature">
                  <div className="services__feature-check">✓</div>
                  <span className="services__feature-text">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}